import sigiriyaImg from '../assets/images/places/sigiriya.jpg';
import templeImg from '../assets/images/places/temple.jpg';
import ellaImg from '../assets/images/places/ella.jpg';
import galleImg from '../assets/images/places/galle.jpg';
import mirissaImg from '../assets/images/places/mirissa.png';
import yalaImg from '../assets/images/places/yala.png';
import anuradhapuraImg from '../assets/images/places/anuradha.jpeg';
import polonnaruwaImg from '../assets/images/places/polonnaruwa.jpg';

// food
import hoppersImg from '../assets/images/food/hoppers.jpeg';
import riceCurryImg from '../assets/images/food/rice.jpeg';
import kottuImg from '../assets/images/food/kottu.jpeg';
import teaImg from '../assets/images/food/tea.jpeg';
import sambolImg from '../assets/images/food/sambol.jpg';
import watalappamImg from '../assets/images/food/watalappam.jpeg';

//vehicle

import minibusImg from '../assets/images/vehicles/mini-bus.png';
import rooftopvanImg from '../assets/images/vehicles/rooftop-van.png';
import sedanImg from '../assets/images/vehicles/sedan.png';
import vanImg from '../assets/images/vehicles/van.png';









export const initialData = {

  

  // Places
  places: [
    {
      id: 1, name: "Sigiriya Rock Fortress", desc: "Ancient palace atop a volcanic rock rising 200m above the jungle. A UNESCO World Heritage masterpiece of 5th-century engineering.", category: "Heritage", rating: "4.9", badge: "UNESCO",
      image: sigiriyaImg
    },
    {
      id: 2, name: "Mirissa Beach", desc: "Golden crescent beach famed for whale watching and spectacular sunsets — the jewel of Sri Lanka's southern coast.", category: "Beach", rating: "4.8", badge: "Popular",
      image: mirissaImg
    },
    {
      id: 3, name: "Temple of the Tooth", desc: "Sacred Buddhist temple in Kandy housing a relic of the Buddha. Site of the magnificent Esala Perahera festival each August.", category: "Temple", rating: "4.9", badge: "Sacred",
      image: templeImg
    },
    {
      id: 4, name: "Ella Highlands", desc: "Misty tea-draped hills with nine-arch bridge views and jungle hikes. The iconic train ride here is one of the world's most scenic.", category: "Nature", rating: "4.7", badge: "Scenic",
      image:ellaImg
    },
    {
      id: 5, name: "Galle Dutch Fort", desc: "17th-century Dutch colonial fortress with charming boutiques and cafés. The fort walls at sunset are a photographer's dream.", category: "Heritage", rating: "4.8", badge: "Heritage",
      image: galleImg
    },
    {
      id: 6, name: "Yala National Park", desc: "Sri Lanka's premier safari destination with the world's highest leopard density. Home to elephants, sloth bears, and crocodiles.", category: "Wildlife", rating: "4.9", badge: "Wildlife",
      image: yalaImg
    },
    {
      id: 7, name: "Arugam Bay", desc: "A world-class surf point on the east coast, beloved by backpackers and pro surfers alike. Best from May to October.", category: "Beach", rating: "4.7", badge: "Surf",
      image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80"
    },
    {
      id: 8, name: "Nuwara Eliya", desc: "The 'Little England' of Sri Lanka — cool highland air, colonial bungalows, and endless emerald tea estates.", category: "Nature", rating: "4.8", badge: "Highland",
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80"
    },
     {
      id: 9,
      name: "Anuradhapura",
      desc: "Sri Lanka's first ancient capital, home to magnificent dagobas, sacred Bodhi tree, and sprawling ruins dating back over 2,500 years. A UNESCO World Heritage Site.",
      category: "Heritage",
      rating: "4.8",
      badge: "Ancient",
      image: anuradhapuraImg,
    },
    {
      id: 10,
      name: "Polonnaruwa",
      desc: "The medieval capital of Sri Lanka featuring beautifully preserved palaces, Buddha statues, and irrigation tanks built by ancient kings over 1,000 years ago.",
      category: "Heritage",
      rating: "4.7",
      badge: "UNESCO",
      image: polonnaruwaImg,
    },
  ],
  packages: [
    {
      id: 1, days: "5", name: "Honeymoon Escape", type: "Honeymoon",
      includes: ["Romantic beachside dinners", "Couples spa sessions", "Sigiriya sunrise tour", "Private sunset cruise", "Luxury hotel stays"],
      highlights: "Romantic Getaways · Scenic Beauty · Luxury Stays",
      tag: "Most Romantic",
      image: "https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=800&q=80"
    },
    {
      id: 2, days: "7", name: "Family Adventure", type: "Family",
      includes: ["Kid-friendly safaris at Yala", "Sigiriya & Dambulla caves", "Ella train ride & hike", "Beach time at Mirissa", "Comfortable family hotels"],
      highlights: "Fun for Everyone · Kid Friendly · Beautiful Memories",
      tag: "Family Favourite",
      image: "https://images.unsplash.com/photo-1501555088652-021faa106b9b?w=800&q=80"
    },
    {
      id: 3, days: "3", name: "Corporate Tour", type: "Corporate",
      includes: ["Team building activities", "Conference facilities", "City & cultural tours", "Premium transport", "Incentive trip planning"],
      highlights: "Meetings · Incentives · Seamless Experiences",
      tag: "Business Ready",
      image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80"
    },
    {
      id: 4, days: "10", name: "Ceylon Grand Tour", type: "Custom",
      includes: ["Full cultural triangle tour", "Safari Yala & Udawalawe", "East & South coast beaches", "Tea plantation stays", "Private English-speaking guide"],
      highlights: "The complete island experience",
      tag: "Premium",
      image: anuradhapuraImg
    },
  ],
  hotels: [
    { id: 1, name: "Heritance Tea Factory", location: "Nuwara Eliya", stars: 5, amenities: ["Spa", "Pool", "Restaurant", "Mountain View", "Tea Tour"], desc: "A former tea factory converted into a luxury mountain retreat.", image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80" },
    { id: 2, name: "Amangalla", location: "Galle Fort", stars: 5, amenities: ["Heritage", "Spa", "Bar", "Garden"], desc: "An 18th-century colonial manor inside the UNESCO-listed Galle Fort.", image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800&q=80" },
    { id: 3, name: "Cinnamon Wild", location: "Yala", stars: 4, amenities: ["Safari", "Pool", "Restaurant", "Wildlife"], desc: "Tented cabanas on the edge of Yala National Park.", image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80" },
    { id: 4, name: "Cape Weligama", location: "Weligama", stars: 5, amenities: ["Infinity Pool", "Spa", "Ocean View", "Bar"], desc: "Cliff-top resort with panoramic Indian Ocean views.", image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80" },
    { id: 5, name: "98 Acres Resort", location: "Ella", stars: 4, amenities: ["Tea Fields", "Pool", "Restaurant", "Hiking"], desc: "Surrounded by working tea estates in misty Ella hills.", image: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80" },
  ],
  foods: [
    {
      id: 1,
      name: "Rice & Curry",
      desc: "A legendary spread of a dozen curries served on a banana leaf with steamed rice. The ultimate Sri Lankan meal.",
      image: riceCurryImg,
      spice: 4,
    },
    {
      id: 2,
      name: "Hoppers (Appa)",
      desc: "Bowl-shaped fermented rice crepes eaten with coconut sambol and egg. A beloved street-food breakfast.",
      image: hoppersImg,
      spice: 2,
    },
    {
      id: 3,
      name: "Kottu Roti",
      desc: "Chopped flatbread stir-fried with vegetables, egg, and protein. The rhythmic clanging of blades is the soundtrack of Sri Lankan night markets.",
      image: kottuImg,
      spice: 3,
    },
    {
      id: 4,
      name: "Ceylon Tea",
      desc: "World-renowned high-grown black tea. Taste it fresh from the estate, brewed in a teapot overlooking misty valleys.",
      image: teaImg,
      spice: 0,
    },
    {
      id: 5,
      name: "Pol Sambol",
      desc: "Fresh coconut relish with chilli, lime, and Maldive fish — a national staple served at every meal.",
      image: sambolImg,
      spice: 4,
    },
    {
      id: 6,
      name: "Watalappam",
      desc: "Rich steamed coconut jaggery pudding with cashews — a Malay-influenced dessert that is intensely sweet.",
      image: watalappamImg,
      spice: 0,
    },
  ],
  vehicles: [
    {
      id: 1,
      name: "Sedan Car",
      cap: "3 passengers",
      features: ["Air Conditioning", "WiFi", "Water", "English Driver"],
      badge: "Economy",
      image: sedanImg
    },
    {
      id: 2,
      name: "SUV",
      cap: "3 passengers",
      features: ["Air Conditioning", "WiFi", "Water", "Phone Charger", "Extra Legroom"],
      badge: "Popular",
      image: "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=400&q=80",
    },
    {
      id: 3,
      name: "Van",
      cap: "6 passengers",
      features: ["Air Conditioning", "WiFi", "Luggage Space", "Water"],
      badge: "Family",
      image:vanImg
    },
    {
      id: 4,
      name: "High Roof Van",
      cap: "10 passengers",
      features: ["Air Conditioning", "High Roof", "WiFi", "Extra Luggage Space", "Water"],
      badge: "Group",
      image: rooftopvanImg
    },
    {
      id: 5,
      name: "Mini Bus",
      cap: "18 passengers",
      features: ["Air Conditioning", "WiFi", "Luggage Compartment", "Water", "PA System"],
      badge: "Large Group",
      image: minibusImg,
    },
    {
      id: 6,
      name: "Under Luggage Bus",
      cap: "34 passengers",
      features: ["Air Conditioning", "Under Luggage Storage", "WiFi", "Reclining Seats", "PA System"],
      badge: "Premium",
      image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=400&q=80",
    },
  ],
};
